import { Injectable } from '@angular/core';
import { FsDataService, RegistryService } from '@fairandsmart/angular';
import {
  DataFilter,
  DataFormat,
  FsData,
  PdsEntry,
  RegistryClass,
  RelevancyIndex,
  SharedPds,
} from '@fairandsmart/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrgaService } from '@Services/orga.service';
import { FlexIndexDocument, FlexSearchService } from '../flex-search.service';
import { DataIndexer } from './data-indexer';
import { FlexIndexDocumentHelper } from '../flex-index-document.helper';
import { BackgroundService } from '../../workers/worker.service';

@Injectable({
  providedIn: 'root'
})
export class SharedPdsIndexerService extends DataIndexer {
  constructor(
    flexSearch: FlexSearchService,
    fsDataService: FsDataService,
    orgaService: OrgaService,
    private registry: RegistryService,
    public backgroundService: BackgroundService,
  ) {
    super(DataFormat.SHARED_PDS, flexSearch, fsDataService, orgaService);
  }

  protected getFilter(since: number, offset: number): DataFilter {
    return {
      format: DataFormat.SHARED_PDS,
      from: since,
      limit: this.batchNumber,
      offset,
      order: 'modificationDate',
    };
  }

  handle(entity: FsData): Observable<FlexIndexDocument> {
    const doc: FlexIndexDocument<string> = FlexIndexDocumentHelper.from(entity);
    return this.backgroundService.getData<SharedPds>(entity.id, { ciphererId: this.orgaService.id }).pipe(
      map((decipheredData) => {
        const sharedPds: SharedPds = decipheredData.clearContent;
        doc.c = '';
        Object.keys(sharedPds.content)
          .filter((k) => k !== 'header')
          .forEach((className) => {
            const registryClass: RegistryClass = this.registry.getRegistry().getClass(className, 'id');
            if (registryClass != null) {
              const entries: PdsEntry[] = sharedPds.content[className];
              entries.forEach((entry: PdsEntry) => {
                doc.c += ` ${registryClass.toString(entry, RelevancyIndex.FULL, ' ')}`;
              });
            }
          });
        doc.c = doc.c.trim();
        return doc;
      }),
    );
  }
}
